import React from "react";
import {useNavigate} from "react-router-dom";
import {Form, Input, Button, Checkbox} from "antd";
import "../assets/css/login.css";
import "firebase/firestore";
import "firebase/auth";
import {signInWithGoogle} from "../components/firebase_config";
import {auth} from "../components/firebase_config";

const Login = () => {
    const navigate = useNavigate();
    auth.onAuthStateChanged((user) => {
        if (user !== null) {
            navigate(`/main`);
        }
    });

    const onFinish = (values) => {
        navigate(`/main`);
    };

    const onFinishFailed = (errorInfo) => {
        alert("로그인 실패");
    };

    return (
        <Form
            name="basic"
            labelCol={{
                span: 8,
            }}
            wrapperCol={{
                span: 16,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            style={{
                width: "100%",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
            }}
        >
            <img
                style={{
                    marginBottom: "40px",
                }}
                src="/assets/images/segim_logo.svg"
                alt="logo"
            />
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                }}
            >
                <Form.Item
                    name="username"
                    style={{
                        width: "320px",
                        height: "50px",
                        border: "1px solid #eaeaea",
                    }}
                >
                    <Input
                        placeholder="아이디를 입력하세요"
                        style={{
                            border: "0",
                            width: "100%",
                            height: "50px",
                            display: "flex",
                            padding: "0",
                        }}
                    />
                </Form.Item>

                <Form.Item
                    name="password"
                    style={{
                        width: "320px",
                        height: "50px",
                        border: "1px solid #eaeaea",
                    }}
                >
                    <Input.Password
                        placeholder="비밀번호를 입력하세요"
                        style={{
                            border: "0",
                            width: "100%",
                            height: "50px",
                            display: "flex",
                            padding: "0",
                        }}
                    />
                </Form.Item>
            </div>
            <Form.Item
                wrapperCol={{
                    offset: 8,
                    span: 16,
                }}
            >
                <Button onClick={signInWithGoogle} type="primary">
                    로그인
                </Button>
            </Form.Item>
        </Form>
    );
};

export default Login;
